import { render, staticRenderFns } from "./specificationAndDocumentation.vue?vue&type=template&id=4e0b34c8&scoped=true"
import script from "./specificationAndDocumentation.vue?vue&type=script&lang=js"
export * from "./specificationAndDocumentation.vue?vue&type=script&lang=js"
import style0 from "./specificationAndDocumentation.vue?vue&type=style&index=0&id=4e0b34c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b34c8",
  null
  
)

export default component.exports